import React, { Suspense } from "react";
import { Routes, Route, Navigate, useParams } from 'react-router-dom'
import Skeleton from "antd/lib/skeleton";
import DiagramLayout from "../../Layout/Diagram";
import CanvopixLayout from "../../Layout/Canvopix";
import NoNeedPermissionLayout from "../../Layout/NoNeedPermission";
import DocumentLayout from "../../Layout/Documents";
import CanvopixProjectLayout from "../../Layout/CanvopixProject";
import AIToolsLayout from "../../Layout/AITools";

import config from 'config'

import * as ROUTER from '../route'

const LabelEditor = React.lazy(() => import(/* webpackChunkName: "label_editor" */'../../pages/LabelEditor'));
const Diagrams = React.lazy(() => import(/* webpackChunkName: "diagrams" */'../../pages/Diagrams'));
const History = React.lazy(() => import(/* webpackChunkName: "history" */'../../pages/History'));
const Favorite = React.lazy(() => import(/* webpackChunkName: "favorite" */'../../pages/Favorite'));
const Trash = React.lazy(() => import(/* webpackChunkName: "trash" */'../../pages/Trash'));
const PrivacyPolicy = React.lazy(() => import(/* webpackChunkName: "privacy_policy" */'../../pages/Documents/Terms/PrivacyPolicy'))
const TermsOfService = React.lazy(() => import(/* webpackChunkName: "terms_of_service" */'../../pages/Documents/Terms/TermsOfService'))
const AboutUs = React.lazy(() => import(/* webpackChunkName: "about_us" */'../../pages/Documents/AboutUs'))
const TemplateList = React.lazy(() => import(/* webpackChunkName: "templates" */'../../pages/Template'))
const TemplateView = React.lazy(() => import(/* webpackChunkName: "templates_view" */'../../pages/TemplateView'))
const TemplateEditor = React.lazy(() => import(/* webpackChunkName: "templates_editor" */'../../pages/TemplateEditor'))
const Setting = React.lazy(() => import(/* webpackChunkName: "setting" */'../../pages/Setting'))
const AuthorizePage = React.lazy(() => import(/* webpackChunkName: "authorize_page" */'../../pages/AuthorizePage'))
const BetterAuth = React.lazy(() => import(/* webpackChunkName: "better_auth" */'../../pages/BetterAuth'));
const Index = React.lazy(() => import(/* webpackChunkName: "index" */'../../pages/Home/sg'));
const AITools = React.lazy(() => import(/* webpackChunkName: "ai_tools" */'../../pages/AITools'));
const Invite = React.lazy(() => import(/* webpackChunkName: "invite" */'../../pages/Invite'));
const InviteCenter = React.lazy(() => import(/* webpackChunkName: "invite_center" */'../../pages/InviteCenter'));

// AI & 工具 相关
const Compress = React.lazy(() => import(/* webpackChunkName: "compress" */'../../pages/Compress'));
const Cutout = React.lazy(() => import(/* webpackChunkName: "cutout" */'../../pages/Cutout'));
const Clearer = React.lazy(() => import(/* webpackChunkName: "clearer" */'../../pages/Clearer'));
const Clip = React.lazy(() => import(/* webpackChunkName: "clip" */'../../pages/Clip'));



const Blog = () => {
  window.location.href = config.domain + '/blogs';
  return null;
}

const FabraEditor = () => {
  const { id } = useParams();
  window.location.href = config.domain + '/editor' + (id ? `?id=${id}` : '');
  return null;
}

import { NotificationBanner } from "@/components/NotificationBanner";

export default () => (
  <Suspense fallback={<Skeleton active />}>
    {/* <NotificationBanner /> */}
    <Routes>
      <Route path={ROUTER.ROUTER_INVITE} element={<Invite />} />
      {/* <Route path={ROUTER_LANDING} element={<LandingPage />} /> */}
      <Route path={ROUTER.ROUTER_BETTER_AUTH} element={<BetterAuth />} />
      <Route path={ROUTER.ROUTER_INDEX} element={<CanvopixLayout />}> 
        <Route index element={<Index />} />
        <Route path={ROUTER.ROUTER_INDEX_PAGE} element={<Index />} />
        <Route path={ROUTER.ROUTER_AI_TOOLS} element={<AITools />} />
        <Route path={ROUTER.ROUTER_HISTORY} element={<History />} />
        <Route path={ROUTER.ROUTER_INDEX} element={<CanvopixProjectLayout />}>
          <Route path={ROUTER.ROUTER_DIAGRAMS} element={<Diagrams />} />
          <Route path={ROUTER.ROUTER_FAVORITE} element={<Favorite />} />
        </Route>
        {/* <Route path={ROUTER.ROUTER_FAVORITE} element={<Favorite />} /> */}
        <Route path={ROUTER.ROUTER_TRASH} element={<Trash />} />
        <Route path={ROUTER.ROUTER_TEMPLATE_LIST} element={<TemplateList />} />
      </Route>

      <Route path={ROUTER.ROUTER_AI_TOOLS} element={<AIToolsLayout />}>
        <Route path={ROUTER.ROUTER_CUTOUT} element={<Cutout />}></Route>
        <Route path={ROUTER.ROUTER_COMPRESS} element={<Compress />}></Route>
        <Route path={ROUTER.ROUTER_CLEARER} element={<Clearer />}></Route>
        <Route path={ROUTER.ROUTER_CLIP} element={<Clip />}></Route>
      </Route>

      <Route path="/label/d/:id" element={<LabelEditor />} />
      <Route path={ROUTER.ROUTER_LABEL_EDITOR_DEFAULT} element={<LabelEditor />} />
      <Route path={ROUTER.ROUTER_AUTHORIZE_PAGE} element={<AuthorizePage />} />

      <Route path="/" element={<DocumentLayout />}>
        <Route path={ROUTER.ROUTER_TERMS_PRIVACY_POLICY} element={<PrivacyPolicy />} />
        <Route path={ROUTER.ROUTER_TERMS_SERVICE} element={<TermsOfService />} />
        <Route path={ROUTER.ROUTER_ABOUT_US} element={<AboutUs />} />
        <Route path={ROUTER.ROUTER_INVITE_CENTER} element={<InviteCenter />} />

      </Route>

      <Route path={ROUTER.ROUTER_SETTING} element={<Setting />} />

      <Route path={ROUTER.ROUTER_AUTHORIZE_PAGE} element={<AuthorizePage />} />

      <Route path="/" element={<NoNeedPermissionLayout />}>
        <Route path={ROUTER.ROUTER_TEMPLATE_VIEW} element={<TemplateView />} />
      </Route>
      <Route path={ROUTER.ROUTER_TEMPLATE_EDIT} element={<TemplateEditor />} />
      <Route path="/blogs" element={<Blog />} />
      <Route path="/editor/:id" element={<FabraEditor />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  </Suspense>
)
